import { render, staticRenderFns } from "./daping.vue?vue&type=template&id=0b78ee0e&scoped=true&"
import script from "./daping.vue?vue&type=script&lang=js&"
export * from "./daping.vue?vue&type=script&lang=js&"
import style0 from "./daping.vue?vue&type=style&index=0&id=0b78ee0e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b78ee0e",
  null
  
)

export default component.exports